module.exports = __webpack_public_path__ + "img/guoshangyun.6b682e7c.jpg";